import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify';
import SignUpOtherData from './SignUpOtherData';
import Input from '../../components/Input';
import Button from '../../components/Button';
import Toast from '../../components/Toast';
import api from '../../services/api';
import {
  Background,
  Container,
  Content,
  SignIn,
  Form,
  ErrorContainer
} from './styled';

const SignUp = () => {
  const [email, setEmail] = useState('');
  useEffect(() => {
    setEmail('');
  }, []);
  const signInValidationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(/^([\w.-]+)@([\w-]+)((\.(\w){2,25})+)$/, 'E-mail inválido')
      .required('E-mail é obrigatório.')
  });

  const { handleSubmit, register, errors, setError } = useForm({
    resolver: yupResolver(signInValidationSchema)
  });

  const onSubmit = async (data) => {
    const params = new URLSearchParams([['email', data.email]]);
    const response = await api.get(
      'http://143.244.202.73:5000/User/CheckForRegisteredEmail',
      { params }
    );

    if (response.data.data.statusResponse === false) {
      setEmail(data.email);
    } else {
      setEmail('');
      toast(<Toast title={`${response.data.data.response}.`} />, {
        type: 'error'
      });
      setError('email', {
        type: 'user-already-exists',
        message: response.data.data.response
      });
    }
  };
  return email === '' ? (
    <Container>
      <Content>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <span>Cadastre-se</span>
          <p>Para se cadastrar precisamos de algumas informações suas:</p>
          <Input
            type="email"
            name="email"
            placeholder="E-mail"
            ref={register}
            error={!!errors.email?.message}
          />
          <ErrorContainer>{errors.email?.message}</ErrorContainer>

          <Button text="Cadastrar" />
          <SignIn>
            <p>Já tem cadastro?</p>
            <Link to="/">Faça o login</Link>
          </SignIn>
        </Form>
      </Content>
      <Background>
        <p>© 2020 ESMenezes - Todos os direitos estão reservados.</p>
      </Background>
    </Container>
  ) : (
    <SignUpOtherData userEmail={email} />
  );
};

export default SignUp;
